import { render, staticRenderFns } from "./RegistrationData.vue?vue&type=template&id=e4b08418"
import script from "./RegistrationData.vue?vue&type=script&lang=js"
export * from "./RegistrationData.vue?vue&type=script&lang=js"
import style0 from "./RegistrationData.vue?vue&type=style&index=0&id=e4b08418&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports